
import { MODAL, modalActions } from '@common-reducers/ModalReducer'
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { BsArchive, BsArrowRightCircle, BsTrash } from 'react-icons/bs'
import { MdClose, MdOutlineContentCopy, MdOutlineFileUpload } from 'react-icons/md'
import classes from './bulk-actions-dialog.module.scss'

import PromptDeleteAction from '@common-components/prompt-delete-action/prompt-delete-action'
import { useEffect, useState } from 'react'
import { getBulkTaskList, hasBulkTasks, bulkActions } from '@common-reducers/BulkActionsReducer'
import { addNewTaskThunk } from '@common-reducers/TaskThunks'
import { deleteOrArchiveSelectedTasks } from '@common-reducers/BulkActionThunks'
import { namespace } from '@common/config/constants'
import { useTranslation } from 'react-i18next'
import { doesTaskBelongToAudienceBoard } from '@common-reducers/BoardsSelectors'

export default function BulkActionsDialog() {
  const { t } = useTranslation(namespace)
  const dispatch = useAppDispatch()
  const bulkTasksList = useAppSelector(getBulkTaskList)
  // An audience is a board under the hood: its rows are contacts, not tasks.
  const firstTaskId = bulkTasksList[0]?._id
  const isAudience = useAppSelector((state) => !!firstTaskId && doesTaskBelongToAudienceBoard(state, firstTaskId))
  const itemLabel = isAudience ? 'contact' : undefined
  const isMoveTo = useAppSelector((state) => state.BulkActionsReducer.isMoveTo)
  const isBulkActionsDialogOpen = useAppSelector(hasBulkTasks)
  const [open, setOpen] = useState(false);
  const direction = useAppSelector((state) => state.UserReducer.direction);
  const drawerIsOpen = useAppSelector(
    (state) => state.TasksReducer.taskViewSideDrawerOpen
);
  useEffect(() => {
    return () => {
      dispatch(bulkActions.toggleMoveTo(false))
    }
  }, [dispatch])


  // duplicate task/s
  function handleDuplicateItems() {
    bulkTasksList.forEach((task) => {
      const clonedTask = { ...task }
      delete clonedTask._id;
      clonedTask.text = `${clonedTask.text} - (${t('taskMenu.duplicateButtonText')})`
      delete clonedTask.order
      dispatch(addNewTaskThunk(clonedTask))
    })
    handleClose()
  }

  // delete task/s
  function handleDelete() {
    setOpen(true);
  }

  const archiveTasks = () => {
    dispatch(deleteOrArchiveSelectedTasks({ deletedOrArchived: "archived", itemLabel }))
  }
  const handleDeleteConfirmationClosed = (shouldDelete?: boolean) => {
    if (shouldDelete === true) {
      dispatch(deleteOrArchiveSelectedTasks({ deletedOrArchived: "deleted", itemLabel }))
    }
    setOpen(false);
  }

  // move to group or board task/s
  function handleMoveTo() {
    dispatch(bulkActions.setBulActionsMoveToId('id'))
    dispatch(bulkActions.toggleMoveTo(!isMoveTo))
  }

  // close the dialog
  function handleClose() {
    dispatch(bulkActions.setBulkTasksMap({}))
    dispatch(bulkActions.setBulActionsMoveToId(''))
    dispatch(bulkActions.toggleMoveTo(false))
    dispatch(bulkActions.setMovingTo(''));

  }


  function openExportModal() {
    if (bulkTasksList.length) {
      dispatch(modalActions.setComponentToRender(MODAL.EXPORT_TO_EXCEL))
    }
  }

  if (!isBulkActionsDialogOpen) return null;

  return (
    <div id="bulkTasksOperations" className={classes.fixed_wrapper} style={{
      color: 'var(--color-primary)',
      width:drawerIsOpen ? "60%" : "84%"
    }}>
      <PromptDeleteAction title={isAudience ? t('taskMenu.promptDeleteContactsTitle') : t('taskMenu.promptDeleteActionTitle')} handleClose={handleDeleteConfirmationClosed} open={open} />
      <div className={classes.dialog_actions_menu}>
        <div style={{
          borderTopLeftRadius: direction === "ltr" ? "9px" : undefined,
          borderBottomLeftRadius: direction === "ltr" ? "9px" : undefined,
          borderBottomRightRadius: direction === "rtl" ? "9px" : undefined,
          borderTopRightRadius: direction === "rtl" ? "9px" : undefined
        }} className={` ${classes.aside_col}  ${classes.aside_left} `}>{bulkTasksList.length}</div>

        <div className={classes.selected_txt}>
          <p>{t('archiveDialog.selectedItems')}</p>
        </div>
        <div className={classes.main_col}>

          <div className={classes.bulk_action_btn_wrap}>
            <button onClick={handleDuplicateItems} className={classes.bulk_action_btn}>
              <span>
                <MdOutlineContentCopy size={20} />
              </span>
              {t('taskMenu.duplicateButtonText')}
            </button>
          </div>

          <div className={classes.bulk_action_btn_wrap}>
            <button onClick={openExportModal} className={classes.bulk_action_btn}>
              <span>
                <MdOutlineFileUpload size={20} />
              </span>
              {t('tasksPanelHeader.export')}
            </button>
          </div>
          {/* <div className={classes.bulk_action_btn_wrap}>
            <button onClick={archiveTasks} className={classes.bulk_action_btn}>
              <span>
                <BsArchive />
              </span>
              Archive
            </button>
          </div> */}

          <div className={classes.bulk_action_btn_wrap}>
            <button data-testid='bulk-action-dialog-delete-button'
              onClick={handleDelete} className={classes.bulk_action_btn}>
              <span>
                <BsTrash size={20} />
              </span>
              {t('taskMenu.deleteButtonText')}
            </button>
          </div>

          <div className={classes.bulk_action_btn_wrap}>
            <button onClick={handleMoveTo} className={classes.bulk_action_btn}
              id={`bulk-actions-menu-id`}
              style={{ position: 'relative' }}>
              <span>
                <BsArrowRightCircle size={20} />
              </span>
              {t('taskMenu.moveToButtonText')}
            </button>
          </div>
        </div>
        <div style={{
          borderInlineStart: "1px solid var(--tasks-cell-border)",
          borderTopLeftRadius: direction === "rtl" ? "9px" : undefined,
          borderBottomLeftRadius: direction === "rtl" ? "9px" : undefined,
          borderBottomRightRadius: direction === "ltr" ? "9px" : undefined,
          borderTopRightRadius: direction === "ltr" ? "9px" : undefined
        }} onClick={handleClose} className={`${classes.aside_col} ${classes.aside_right}`}>
          <MdClose size={24} />
        </div>
      </div>
    </div >
  )
}
